module.exports = __webpack_public_path__ + "img/humidity.5d2d407e.svg";